<template>
    <b-modal id="modalItemsExterna" data-backdrop="static" data-keyboard="false" v-model="exibirItens" centered
        :title="this.$t('Confirmar OS Externa')">
        <h3></h3>
        <p>{{ `${$t('Deseja realmente enviar OS')} N°${this.$route.params.id}?` }}</p>
        <v-select :options="getFornecedores" v-model="fornecedores" :placeholder="$t('Fornecedor')"></v-select>

        <div class="mt-3">
            <span for="obsItem">{{ $t('Observação') }}:</span>
            <input v-model="obsExterna" type="text" class="form-control" id="obsItem">
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center;">
                    <b-button class="mr-2" variant="danger" size="lg" @click="$emit('fechaModal')">
                        {{ $t('Cancelar') }}
                    </b-button>
                    <b-button size="lg" variant="success" @click="submitValues">
                        {{ $t('Enviar OS') }}
                    </b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>

export default {
    name: "ModalExterna",
    props: {
        os: {},
        item: {}
    },
    data() {
        return {
            selectServico: "",
            obsExterna: "",
            exibirItens: true,
            idConjunto: "",
            fornecedores: ""
        };
    },
    computed: {
        getFornecedores() {
            const fornecedores = this.$store.getters['filial/fornecedores']

            if (!fornecedores) {
                this.$store.dispatch('filial/getFornecedores')
                return []
            }

            return fornecedores.map(fornecedor => {
                return {
                    ...fornecedor,
                    label: fornecedor.ds_fornecedor
                }
            })
        }
    },

    methods: {
        submitValues() {
            this.$store.dispatch('os/getDetails', { nrSequencial: this.$route.params.id }).then(response => {
                const execucao = {
                    nr_os: Number(this.$route.params.id),
                    obs: this.obsExterna,
                    adm: false,
                    nr_seq_fornecedor: this.fornecedores.nr_sequencial
                }

                const filial = this.$store.getters['filial/filial']

                if (filial.atendeOs != "S") {
                    execucao.adm = true
                }

                if (response.data.execucao_inicio) {
                    this.cod_item = this.item.nr_seq_item

                    const execucaoParar = {
                        id: this.item.execucao_final.id,
                        nr_seq_os_item_update: this.cod_item,
                        nr_seq_os_item: this.item.nr_sequencial,
                        nr_seq_os: this.$route.params.id,
                        nr_seq_clifor: response.data.execucao_inicio.nr_seq_clifor_inicio,
                        nr_os: this.$route.params.id,
                        validaExt: false,
                        obsExterna: this.obsExterna,
                        osExterna: false,
                    }

                    //   this.enviaOsExterna()
                    this.$emit('enviaOsExterna', { ...execucao }) 

                    this.$store.dispatch('osItemExecucao/update', { data: execucaoParar }).then(response => {
                        this.$store.dispatch('osItem/fetchItemFromApi', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                        this.$store.dispatch('osItem/fetchItemFromApiPreventiva', { nrSeqOs: this.$route.params.id, nrSequencial: this.item.nr_sequencial })
                    })
                    //   this.parar('', execucao)
                    console.log('Executa o parar')
                } else {
                    this.$emit('enviaOsExterna', { ...execucao })

                    //   this.enviaOsExterna(execucao)
                }

            })


        },

    },
}
</script>
<style>
#modalItems {
    pointer-events: none !important;
}

.close {
    display: none !important;
}
</style>